<template>
  <section
    class="testimonial section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]"
  >
    <div class="container">
      <div
        class="testimonial-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item reveal-from-right" data-reveal-delay="200">
            <div class="tiles-item-inner">
              <div class="testimonial-item-content">
                <p class="text-sm mb-0">
                  — You were a massive part of getting our MVP to market and
                  enabling us to keep major clients engaged with feature updates
                  as we grew.
                </p>
              </div>
              <div class="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                <span class="testimonial-item-name text-color-high">Chris C</span>
                <span class="text-color-low">/</span>
                <span class="testimonial-item-link">
                  <a href="https://firstaml.co.nz">First AML</a>
                </span>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-left" data-reveal-delay="200">
            <div class="tiles-item-inner">
              <div class="testimonial-item-content">
                <p class="text-sm mb-0">
                  — Working with you has allowed us to offer technical solutions
                  to our clients' most complex problems, increasing the LTV of
                  our clients and positioning us as a go to solutions provider.
                </p>
              </div>
              <div class="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                <span class="testimonial-item-name text-color-high">Jeff D</span>
                <span class="text-color-low">/</span>
                <span class="testimonial-item-link">
                  <a href="https://conversations.business">Conversations.business</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";

export default {
  name: "CTestimonial",
  components: {
    CSectionHeader
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: "Over 5 years of custom web apps",
        paragraph:
          "I've been delighting clients with custom purpose-built web apps since 2014, and I'm excited to work with you too."
      }
    };
  }
};
</script>
